module.exports = __webpack_public_path__ + "img/preloader.3e803924.gif";